<template>
    <img
        src="/images/logo.png"
        style="max-width: 325px;"
    />
</template>
